// extracted by mini-css-extract-plugin
export default {"r_l":"cf8a60d8e7 e100bc8798","t":"_12cb817ef6"};